import React from 'react';
import { Checkbox, Col, Row, Typography } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import { sectionVariants } from './animations';
import '../../search/assets/css/date-search.css';

const { Text } = Typography;

export const anyTypesSelected = (dateSearchState) => {
  const { bookingTypes = {} } = dateSearchState;
  return Object.entries(bookingTypes).some(([, v]) => v);
}

export const SelectedTypesText = ({
  dateSearchState,
  summaryText = 'Booking Type',
  summaryPlural = false,
  placeholder = 'Add Booking Type(s)',
}) => {
  const { bookingTypes } = dateSearchState;
  const selectedTypes = Object.keys(bookingTypes).filter(
    (key) => bookingTypes[key]
  );
  const numTypes = selectedTypes.length;
  if (!numTypes) {
    return placeholder;
  }
  const text = summaryText + (summaryPlural && numTypes !== 1 ? 's' : '');
  return `${numTypes} ${text}`;
};

const BookingTypeSection = ({
  collapseOpen,
  dateSearchState,
  updateDateSearchState,
  specificSwim,
  watercraftTicket,
  lakeExclusives,
  accommodation,
  withAnimation = true,
}) => {
  const content = (
    <div className='section-content gMedium'>
      <div style={{ padding: 16 }}>
        <div
          style={{
            display: 'block',
            color: 'black',
            marginBottom: 12,
          }}
        >
          Select Booking Type(s)
        </div>

        {/* 1. Specific Swims */}
        <Row align='middle' style={{ marginBottom: 12 }}>
          <Col
            className='sb-blue-bg-100'
            style={{
              padding: 8,
              borderRadius: 8,
              marginRight: 12,
              width: 40,
              height: 40,
              textAlign: 'center',
            }}
          >
            <img
              src={specificSwim}
              alt='specific-swim'
              style={{ width: 18, height: 18 }}
            />
          </Col>
          <Col flex='auto'>
            <Text className='gMedium sb-grey-900 fs-15'>Specific Swims</Text>
          </Col>
          <Col>
            <Checkbox
              checked={dateSearchState.bookingTypes.specificSwims}
              onChange={(e) =>
                updateDateSearchState(
                  'bookingTypes.specificSwims',
                  e.target.checked
                )
              }
            />
          </Col>
        </Row>

        {/* 2. Watercraft Tickets */}
        <Row align='middle' style={{ marginBottom: 12 }}>
          <Col
            style={{
              padding: 8,
              borderRadius: 8,
              marginRight: 12,
              width: 40,
              height: 40,
              textAlign: 'center',
            }}
            className='sb-blue-bg-100'
          >
            <img
              src={watercraftTicket}
              alt='watercraft-ticket'
              style={{ width: 18, height: 18 }}
            />
          </Col>
          <Col flex='auto'>
            <Text className='gMedium sb-grey-900 fs-15'>
              Watercraft Tickets
            </Text>
          </Col>
          <Col>
            <Checkbox
              checked={dateSearchState.bookingTypes.watercraftTickets}
              onChange={(e) =>
                updateDateSearchState(
                  'bookingTypes.watercraftTickets',
                  e.target.checked
                )
              }
            />
          </Col>
        </Row>

        {/* 3. Lake Exclusives */}
        <Row align='middle' style={{ marginBottom: 12 }}>
          <Col
            style={{
              padding: 8,
              borderRadius: 8,
              marginRight: 12,
              width: 40,
              height: 40,
              textAlign: 'center',
            }}
            className='sb-blue-bg-100'
          >
            <img
              src={lakeExclusives}
              alt='lake-exclusives'
              style={{ width: 18, height: 18 }}
            />
          </Col>
          <Col flex='auto'>
            <Text className='gMedium sb-grey-900 fs-15'>Lake Exclusives</Text>
          </Col>
          <Col>
            <Checkbox
              checked={dateSearchState.bookingTypes.lakeExclusives}
              onChange={(e) =>
                updateDateSearchState(
                  'bookingTypes.lakeExclusives',
                  e.target.checked
                )
              }
            />
          </Col>
        </Row>

        {/* 4. Accommodation */}
        <Row align='middle'>
          <Col
            className='sb-blue-bg-100'
            style={{
              padding: 8,
              borderRadius: 8,
              marginRight: 12,
              width: 40,
              height: 40,
              textAlign: 'center',
            }}
          >
            <img
              src={accommodation}
              alt='accommodation'
              style={{ width: 18, height: 18 }}
            />
          </Col>
          <Col flex='auto'>
            <Text className='gMedium sb-grey-900 fs-15'>Accommodation</Text>
          </Col>
          <Col>
            <Checkbox
              checked={dateSearchState.bookingTypes.accommodation}
              onChange={(e) =>
                updateDateSearchState(
                  'bookingTypes.accommodation',
                  e.target.checked
                )
              }
            />
          </Col>
        </Row>
      </div>
    </div>
  );

  if (!withAnimation) {
    return collapseOpen === 'type' ? content : null;
  }

  return (
    <AnimatePresence>
      {collapseOpen === 'type' && (
        <motion.div
          initial='closed'
          animate='open'
          exit='closed'
          variants={sectionVariants}
          style={{ overflow: 'hidden' }}
        >
          {content}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BookingTypeSection;
